import GlobalBanner from "./GlobalBanner";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaClock,
  FaDirections,
} from "react-icons/fa";
import { LOCATION_LIST } from "../data/locations";
import { useSelectedLocation } from "../context/LocationContext";

function ContactUs() {
  const { location, locationId, setLocationId } = useSelectedLocation();

  const items = [
    {
      Icon: FaMapMarkerAlt,
      title: "Address",
      content: location.address,
    },
    {
      Icon: FaClock,
      title: "Opening Hours",
      content: (
        <>
          <span className="font-semibold">{location.hours[0]}</span>
          <br />
          <span className="font-semibold">{location.hours[1]}</span>
        </>
      ),
    },
    {
      Icon: FaPhoneAlt,
      title: "Call Us",
      content: (
        <a href={location.phoneHref} className="hover:text-primary">
          {location.phoneDisplay}
        </a>
      ),
    },
    {
      Icon: FaEnvelope,
      title: "Email Us",
      content: location.email,
    },
  ];

  return (
    <div>
      <GlobalBanner
        title="Contact Us"
        subtitle="Contact us"
        bgImage="/images/secondhome_outer.webp"
      />
      <div className="py-16 px-6 bg-cream">
        <div className="container mx-auto px-4">
          {/* Section Title */}
          <div className="text-center mb-8">
            <h1 className="text-2xl md:text-4xl font-bold mb-5">Contact Us</h1>
            <h5 className="text-primary-dark font-semibold mb-6">
              We would love to hear from you. Choose a branch to see its
              details.
            </h5>

            {/* Location tabs */}
            <div className="inline-flex rounded-full bg-white shadow-md p-1">
              {LOCATION_LIST.map((loc) => (
                <button
                  key={loc.id}
                  onClick={() => setLocationId(loc.id)}
                  className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${
                    locationId === loc.id
                      ? "bg-primary text-ink"
                      : "text-gray-600 hover:text-primary-dark"
                  }`}
                >
                  {loc.name}
                </button>
              ))}
            </div>
          </div>

          <div className="space-y-6">
            {/* Map and Contact Cards */}
            <div className="grid grid-cols-1 items-stretch md:grid-cols-2 gap-6">
              {/* Google Map */}
              <div className="flex flex-col gap-4">
                <iframe
                  key={location.id}
                  title={`${location.name} map`}
                  className="w-full h-[350px] rounded-xl shadow-lg"
                  src={location.mapEmbedSrc}
                  frameBorder="0"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  aria-hidden="false"
                  tabIndex="0"
                ></iframe>
                <div className="flex gap-3">
                  <a
                    href={location.directionsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex items-center justify-center gap-2 bg-primary hover:bg-primary-dark text-ink font-semibold py-3 rounded-lg transition-colors"
                  >
                    <FaDirections /> Get Directions
                  </a>
                  <a
                    href={location.phoneHref}
                    className="flex-1 flex items-center justify-center gap-2 bg-ink hover:bg-ink-light text-white font-semibold py-3 rounded-lg transition-colors"
                  >
                    <FaPhoneAlt /> Call Now
                  </a>
                </div>
              </div>

              {/* Contact Cards */}
              <div className="grid md:grid-cols-1 gap-4">
                {items.map((item, idx) => (
                  <div
                    key={idx}
                    className="flex bg-white shadow-[0_0_20px_rgba(0,0,0,0.08)] p-4 items-start space-x-3 rounded-xl transition-transform hover:-translate-y-0.5"
                  >
                    <div className="bg-primary rounded-full p-2 flex items-center justify-center">
                      <item.Icon className="text-ink text-lg" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-gray-700 text-sm">{item.content}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
